import { InfoIcon, UserSettingsIcon, VibrateIcon } from '@/assets/icons';
import { routesApp } from '@/constans/routes';

interface RouteSettings {
    translationKey: string;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    path: string;
    value: string;
}

export const dataSettingsRoutes: RouteSettings[] = [
    {
        translationKey: 'profile.personal_data',
        icon: UserSettingsIcon,
        path: routesApp.profileEdit,
        value: 'personal_data',
    },
    {
        translationKey: 'profile.terms_of_service',
        icon: InfoIcon,
        path: routesApp.termsOfService,
        value: 'terms_of_service',
    }
];
